import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const CourseMaster = React.lazy(() => import("@/pages/iiy/hr/CourseMaster"));
const IdeaCategory = React.lazy(() => import("@/pages/iiy/hr/IdeaCategory"));
const AsHR = React.lazy(() => import("@/pages/iiy/hr/AsHR"));
const EmployeeMyself = React.lazy(() => import("@/pages/iiy/employee/Index"));
const AsIIYDashboard = React.lazy(
  () => import("@/pages/iiy/employee/AsIIYDashboard"),
);
const TeamActivityReport = React.lazy(
  () => import("@/pages/iiy/reportingManager/Index"),
);
const IIYReport = React.lazy(() => import("@/pages/iiy/divisionHead/Index"));
const IIYDashboard = React.lazy(
  () => import("@/pages/iiy/dashboard/Dashboard"),
);

const IIY = [
  {
    path: "IIY/courseMaster",
    element: (
      <SuspenseWrapper>
        <CourseMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ideaCategory",
    element: (
      <SuspenseWrapper>
        <IdeaCategory />
      </SuspenseWrapper>
    ),
  },
  {
    path: "IIY/asHR",
    element: (
      <SuspenseWrapper>
        <AsHR />
      </SuspenseWrapper>
    ),
  },
  {
    path: "IIY/asEmployee",
    element: (
      <SuspenseWrapper>
        <EmployeeMyself />
      </SuspenseWrapper>
    ),
  },
  {
    path: "IIY/asIIYDashboard",
    element: (
      <SuspenseWrapper>
        <AsIIYDashboard />
      </SuspenseWrapper>
    ),
  },
  {
    path: "IIY/asReportingManager",
    element: (
      <SuspenseWrapper>
        <TeamActivityReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "IIY/asDivisionHead",
    element: (
      <SuspenseWrapper>
        <IIYReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "IIY/asDashboard",
    element: (
      <SuspenseWrapper>
        <IIYDashboard />
      </SuspenseWrapper>
    ),
  },
];

export default IIY;
